
import PageView from "app/tracking/google/page_view"
import $ from "jquery"
import _once from "lodash/once"


import I18n from "plugins/i18n-js"


const main = ".cell-listings-banner-advertisements"

function track_path(advertiser_identifier: string) {
  return [
    "/fake-path",
    "/apps/spacious-web-app",
    `/${I18n.locale}`,
    "/pages/listings/show",
    "/banner/advertisements",
    `/${advertiser_identifier}`,
    "/events/view",
  ].join("")
}


const init = _once(() => {
  const $main = $(main)
  $main.each(() => {
    PageView.track(track_path($main.data("advertiser-identifier")))
  })
})

export default { init }
